<template>
    <div class="mainHolder">
        <div id="sec-one">
            <div class="outer">
                <div class="content middle">
                    <div class="item">
                        <p class="title-m loginPage">MESSENGER</p>
                        <form  class="login-form" @submit.prevent="doLogin">    
                            
                            <div class="field-form">
                                <label>Login</label>
                                <input 
                                    type="text"
                                    v-model.trim="email"
                                >
                            </div>
                            <div class="field-form">
                                <label>Password</label>
                                <input 
                                    type="password"
                                    v-model.trim="pass1"
                                >
                               
                            </div>
                            <div class="field-form" v-if="showError" >
                                    <div class="alert error">
                                        <!--<span class="closebtn" v-on:click="showError = !showError">&times;</span> -->
                                        {{showError}}.
                                    </div>   
                            </div>
                            <div class="field-form">
                                <button 
                                    type="submit"
                                    :disabled="bloquear || sendingForm"
                                >
                                    
                                    <span v-if="!sendingForm">LOGIN</span> <span class="fa-1x" v-if="sendingForm"><i class="fas fa-spinner fa-spin"></i></span>
                                </button>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div id="sec-two">
            <div class="outer">
                <div class="content notTop middle">
                    <div class="p15">
                        <div class="item"><img src="../assets/images/logo.png" class="img-max-w"></div>
                        <div class="content-one">
                            <p class="title"><span>Nothing but</span> <span class="slogan">HEAVY DUTY. <sup class="registeredSign">&#174;</sup></span></p>
                        </div>
                        <div class="content-two">
                            <p class="sub-title">READY FOR PICK UP!</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//import { mapActions, mapMutations } from 'vuex'
import store from '../store'
import axios from "axios";
import router from "../router"
export default {
    data() {
        return {
            email: '',
            pass1: '',
            showError: false,
            sendingForm: false
        }
    },
    computed: {
        bloquear(){
            //this.$toast.show(`Default Toast Message`);
            if(!this.email.includes('@')){
                return true
            }
            /*
            if(this.pass1.length > 5){
                return false
            }
            */
            return false
            
        },

    },
    methods: {

       //==========================
       //Get data token login
        //==========================
        doLogin(){
                const self = this
                let formData = new FormData();
                formData.append("username", this.email);
                formData.append("password", this.pass1);
                self.sendingForm = true
                axios({
                    method: "post",
                    url: `auth/login`,
                    responseType: "json",
                    data: formData,
                    /*headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: "Bearer " + dataUser.data.jwt
                    }
                    */
                })
                .then(function(response) {
                    if (response.data) {

                        localStorage.setItem('token',response.data.data.jwt)
                        localStorage.setItem('isAuthenticated', 1)
                        
                        store.commit("setAuthenticated", true)
                        



                        self.getUserInfo()
                        self.sendingForm = false
                        router.push('/')

                    }else{
                        //self.sendingForm = false
                        self.callToast(`There was an error`, 'warning')
                    }

                    self.sendingForm = false
                })
                .catch(error => (self.showError = (`${error}`),(self.sendingForm = false)));
        },

        //==========================
        //Get User Info
         //==========================
        getUserInfo(){
            const self = this;
                axios({
                    method: "get",
                    url: `auth/me`,
                    responseType: "json",
                    //data: formData,
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: "Bearer " + localStorage.getItem('token')
                    }

                })
                .then(function(response) {
                    if (response.data) {

                        localStorage.setItem('user_info',JSON.stringify(response.data))

                        store.commit("setUsername", response.data.data.name)
                        store.commit("setUserId", response.data.data.id)
                    }else{
                        self.callToast(`There was an error`, 'warning')
                    }

                    self.sendingForm = false
                })
                .catch(error => (self.callToast(`There was an error: ${error}`, 'warning'), (self.sendingForm = false))); 
        },

        callToast(message, status){
            this.$toast.show(message, {
                type: status,
                position: 'top-right'
                // all of other options may go here
            });
        },
    },
}
</script>

<style>

</style>